import debounce from 'lodash/debounce';
import { IndexedProductPrice } from '@priceOptimizer/models/indexedProductPrice';
import * as api from './api';
import * as MutationTypes from './mutationTypes';
import { ProductRecommendation } from './models';

export const productPriceRecommendationsRequest = async ({ commit }, predictionPeriodGuid) => {
  const res = await api.productPriceRecommendationsRequest(predictionPeriodGuid);
  const productRecommendationMap = ProductRecommendation.toInstanceMap(res.data.product_price_recommendation_list);
  commit(MutationTypes.PRODUCT_RECOMMENDATION_MAP_SUCCESS, productRecommendationMap);
};

export const saveProductPriceRecommendationsRequest = async ({ getters: { productRecommendationMap } }, periodGuid) => {
  const serializedList = [];
  productRecommendationMap.forEach((recommendation) => {
    serializedList.push(recommendation.serialize());
  });
  await api.saveProductPriceRecommendationsRequest(periodGuid, serializedList);
};

export const setProductPriceRecommendationsConfirmed = ({ commit }, { productRecommendationGuids, confirmed }) => {
  commit(MutationTypes.SET_PRODUCT_PRICE_RECOMMENDATIONS_CONFIRMED, { productRecommendationGuids, confirmed });
};

export const updateProductPriceRecommendation = ({ commit }, {
  productRecommendation,
  groupCodeName,
  demandObject
}) => {
  commit(MutationTypes.UPDATE_PRODUCT_PRICE_RECOMMENDATION, { productRecommendation, groupCodeName, demandObject });
};

export const debouncedProfitabilityRequest = debounce(async ({ dispatch, state }, periodGuid) => {
  const priceChangesList = [];
  state.productRecommendationMap.forEach((recommendation) => {
    priceChangesList.push(...recommendation.getPriceChangesList());
  });
  await dispatch('priceProfitabilityRequest', { periodGuid, priceChangesList });
}, 2000);

export const setFilterByPriceGroup = ({ commit }, filter) => {
  commit(MutationTypes.SET_FILTER_BY_PRICE_GROUP, filter);
};

export const selectPriceLanguage = ({ commit }, language) => {
  commit(MutationTypes.SELECT_PRICE_LANGUAGE, language);
};

export const indexedProductPriceRequest = async ({ commit }, predictionPeriodGuid) => {
  const res = await api.indexedProductPriceRequest(predictionPeriodGuid);
  const useOneService = res.data.use_one_service;
  const indexedProductPrices = IndexedProductPrice.toInstanceList(res.data.prices);
  commit(MutationTypes.USE_ONE_SERVICE_SUCCESS, useOneService);
  commit(MutationTypes.INDEXED_PRODUCT_PRICE_SUCCESS, indexedProductPrices);
};
